import React from 'react';
import s from './HotSearches.scss';
import { LinkWrapper } from '../BaseComp';
import { transposeMatrix } from '../../utils';

export const HotSearches = (props: {hotSearch: string[]}) => {
    const { hotSearch } = props;
    const displayData = transposeMatrix(hotSearch.slice(0, 8), 2);
    const indexes = transposeMatrix(Array(8).fill(1).map((_, i) => i + 1), 2);
    return (
        <div className={s.hot} data-spm="top-hotwords">
            {displayData.map((item, index) =>
                <LinkWrapper
                    key={index}
                    href={`//search.sohu.com/?keyword=${item}&type=1&queryType=hot-query`}>
                    <span className={indexes[index] < 4 ? s.active : ''}>{indexes[index]}</span>
                    <p>{item}</p>
                </LinkWrapper>,
            )}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/HotSearches/index.tsx